import styled from "styled-components";
import { FaInstagram, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { ReactComponent as Logo } from "./logo.svg";

const FooterElement = styled.footer`
  background: #fffcf2;
  width: 100%;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  align-items: center;
  padding: 1rem 0rem;
`;
const FooterLeft = styled.div`
  display: flex;
  margin: 0;
  align-items: center;
  justify-content: center;

  > * {
    margin: 0;
  }

  > svg {
    cursor: pointer;
  }
`;
const FooterCenter = styled.div`
  text-align: center;

  > p {
    color: #82755fff;
    font-size: 0.8em;
  }

  @media (max-width: 780px) {
    padding: 0 15px;
  }
`;

const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;

  width: auto;
  height: auto;
`;

const Social = styled.button`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  border-color: rgb(0, 0, 0, 0.3);
  background: white;

  > * {
    color: black;
    max-width: 1rem;
    max-height: 1rem;
  }

  &:hover {
    box-shadow: 0 11px 10px rgba(0, 0, 0, 0.1);
    background: rgba(235, 95, 40, 0.6);
    border: 1px solid rgba(235, 95, 40, 0.05);

    > * {
      color: white;
    }
  }
`;

function Footer() {
  return (
    <FooterElement>
      <FooterLeft>
        <Logo style={{ width: "3rem", height: "auto" }}></Logo>
        <div className="site_name">Smarcuit</div>
      </FooterLeft>

      <FooterCenter>Built from the circuit up.</FooterCenter>

      <FooterRight>
        <div style={{ display: "flex", gap: "10px" }}>
          <Social
            onClick={() => (window.location.href = "https://x.com/smarcuit")}
          >
            <FaXTwitter></FaXTwitter>
          </Social>
          <Social style={{ display: "none" }}>
            <FaInstagram></FaInstagram>
          </Social>
          <Social
            onClick={() => {
              window.location.href =
                "https://www.linkedin.com/company/smarcuit";
            }}
          >
            <FaLinkedin></FaLinkedin>
          </Social>
        </div>
      </FooterRight>
      <FooterCenter>
        <p>Copyright &copy; {new Date().getFullYear()} Smarcuit Inc.</p>
        <p>
          &copy; {new Date().getFullYear()} NVIDIA, the NVIDIA logo, and
          Inception Program are trademarks and/or registered trademarks of
          NVIDIA Corporation in the U.S. and other countries.
        </p>
      </FooterCenter>
    </FooterElement>
  );
}

export default Footer;
